import { Spinner } from "react-bootstrap";

export default function Loader() {
  return <Spinner animation="border" />;
}
